import { Location } from '@angular/common';
import { Component } from '@angular/core';

import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { ErrorDecoderHelper } from '../../helpers/error-decoder/error-decoder.helper';
import { FormatedErrorInterface } from '../../interface/error-state.interface';

@Component({
  selector: 'app-not-authenticated-error',
  templateUrl: './not-authenticated-error.component.html',
  styleUrls: ['./not-authenticated-error.component.scss']
})
export class NotAuthenticatedErrorComponent {
  codeError?: string;
  correlationId?: string;

  constructor(private analyticsService: AnalyticsService, private locationState: Location) {
    const locationStateError = ((this.locationState.getState() as FormatedErrorInterface) || {}).error;

    this.codeError = ErrorDecoderHelper.getCodeErro(locationStateError);
    this.correlationId = ErrorDecoderHelper.getCorrelationId(locationStateError);

    const statusCode = locationStateError?.statusCode?.toString() ?? 'nao-autenticado';
    this.trackNotAuthenticatedError(statusCode);
  }

  trackNotAuthenticatedError(statusCode: string) {
    this.analyticsService.trackError(`erro:autenticacao:${statusCode.toLowerCase()}:${this.correlationId?.toLowerCase()}`);
  }
}
